var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStealSkill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5999 9.26315V11.7895H15.9997V13.4737H13.5991L13.5999 16H12L11.9992 13.4737H9.60015V11.7895H12V9.26315H13.5999ZM14.5942 1.47956C16.4037 3.38946 16.4661 6.43115 14.783 8.41431L13.6471 7.2202C14.7118 5.93683 14.6558 3.9242 13.4615 2.66946C12.2592 1.40714 10.3257 1.35325 9.06978 2.54062L8.00185 3.54946L6.93313 2.54146C5.67322 1.35241 3.74055 1.40462 2.53823 2.67114C1.34631 3.92588 1.28632 5.93431 2.38464 7.26146L9.12978 14.3739L8.00026 15.5663L1.21672 8.41515C-0.466363 6.43115 -0.403167 3.38441 1.40551 1.47956C3.21738 -0.426965 6.11558 -0.490965 8.00026 1.28756C9.87933 -0.488439 12.7831 -0.429491 14.5934 1.47956H14.5942Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStealSkill);
export default __webpack_public_path__ + "static/media/steal-skill.bbae315a49a7c099374aa78c66ec7002.svg";
export { ForwardRef as ReactComponent };